import {
    AreaBookingFormElement,
    AreaBookingFormElementWrapper,
    SectionHeading,
} from "./style";
import { useFormikContext } from "formik";

import { BookingSettings } from "../model/generalData";
import { FormikInput } from "shared/components/FormikInput";

interface AreaBookingSettingsProps {
    isEditable: boolean
}
export function AreaBookingSettings({ isEditable }: AreaBookingSettingsProps) {
    const { values } = useFormikContext<any>();
    return (
        <>
            <SectionHeading>Зал</SectionHeading>
            <AreaBookingFormElementWrapper>
                {BookingSettings.map((item, itemIndex) => {
                    return (
                        <AreaBookingFormElement key={itemIndex}>
                            <FormikInput
                                required={item.required}
                                name={item.name}
                                label={item.label}
                                placeholder={item.placeholder}
                                type={item.type}
                                disabled={!isEditable || (item.disabled ?? false)}
                                value={values[item.name]}
                                maskConfig={item.maskConfig}
                                className="inputForm"
                                $afterIcon="clearInput"
                            />
                        </AreaBookingFormElement>
                    );
                })}
            </AreaBookingFormElementWrapper>
        </>
    );
}
